/* Quote builder — step navigation, design filter, "Let us spec it" / "I know my specs". */
(function () {
  'use strict';
  var W = window.WWC || {};
  document.querySelectorAll('[data-qb]').forEach(function (root) {
    var form = root.querySelector('form');
    if (!form || !root.querySelector('[data-qb-panel]')) return;
    root.classList.add('qb--js');
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var vehicle = $('[data-qb-vehicle]'), err = $('[data-qb-error]');

    /* ----- prefill the car from ?vehicle= or My garage ----- */
    var q = new URLSearchParams(location.search).get('vehicle');
    var g = W.getGarage && W.getGarage();
    if (vehicle && !vehicle.value) {
      if (q) vehicle.value = q;
      else if (g && g.make) vehicle.value = (g.year ? g.year + ' ' : '') + g.make + ' ' + (g.model || '');
    }

    /* ----- steps ----- */
    function show(n, focus) {
      $$('[data-qb-panel]').forEach(function (p) { p.hidden = p.dataset.qbPanel !== String(n); });
      $$('[data-qb-step]').forEach(function (s) {
        var i = +s.dataset.qbStep;
        s.classList.toggle('is-active', i === n);
        s.classList.toggle('is-done', i < n);
        if (i === n) s.setAttribute('aria-current', 'step'); else s.removeAttribute('aria-current');
      });
      if (n === 3) summary();
      if (focus) {
        var t = $('[data-qb-panel="' + n + '"] .qb__title');
        var top = root.querySelector('.qb__card').getBoundingClientRect().top;
        if (top < 0) root.querySelector('.qb__card').scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (t) t.focus({ preventScroll: true });
      }
    }
    function carOk() {
      if (vehicle.value.trim()) return true;
      vehicle.setAttribute('aria-invalid', 'true');
      err.textContent = 'Add your car so we can size the wheels.';
      err.hidden = false;
      show(1, false);
      vehicle.focus();
      return false;
    }
    vehicle.addEventListener('input', function () { vehicle.removeAttribute('aria-invalid'); err.hidden = true; });
    vehicle.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (carOk()) show(2, true); } });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qb-go]'); if (!b) return;
      var n = +b.dataset.qbGo;
      if (n > 1 && !carOk()) return;
      show(n, true);
    });

    /* ----- wheel type filters the designs ----- */
    var count = $('[data-qb-count]');
    function filter() {
      var t = $('[data-qb-type]:checked'), id = t ? t.dataset.qbType : '';
      var n = 0;
      $$('[data-qb-for]').forEach(function (d) {
        var on = d.dataset.qbFor === 'all' || d.dataset.qbFor === id;
        d.hidden = !on;
        if (on && d.dataset.qbFor !== 'all') n++;
        if (!on) { var r = d.querySelector('input'); if (r.checked) { r.checked = false; $('[data-qb-for="all"] input').checked = true; } }
      });
      if (count) count.textContent = n ? n + ' designs' : '';
      var box = $('[data-qb-designs]'); if (box) box.scrollLeft = 0;
      ref();
    }
    var refBox = $('[data-qb-ref]');
    function ref() { var c = $('[data-qb-custom]'); if (refBox) refBox.hidden = !(c && c.checked); }

    /* ----- "Let us spec it" / "I know my specs" ----- */
    var own = $('[data-qb-own]');
    function help() {
      var m = $('[data-qb-help]:checked'), isOwn = m && m.dataset.qbHelp === 'own';
      own.hidden = !isOwn;
      own.querySelectorAll('input').forEach(function (i) { i.disabled = !isOwn; });
    }

    function summary() {
      var el = $('[data-qb-summary]'); if (!el) return;
      var t = $('[data-qb-type]:checked'), d = $('[name="contact[Design]"]:checked');
      var bits = [vehicle.value.trim(), t && t.value, d && d.value].filter(Boolean);
      el.textContent = bits.join(' · ');
      el.hidden = !bits.length;
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-qb-type]')) filter();
      if (e.target.name === 'contact[Design]') ref();
      if (e.target.matches('[data-qb-help]')) help();
    });
    form.addEventListener('submit', function (e) { if (!carOk()) e.preventDefault(); });

    filter(); help();
    var start = $('[data-qb-start]');
    show(start ? 3 : 1, false);
  });
})();
